import { getCache } from '../../entity-cache/entity-cache.js';
import type { SchoolCacheData } from '../../entity-cache/school-cache.js';
import { SCHOOL_CACHE_KEY } from '../../entity-cache/school-cache.js';

export async function getAllSchools(): Promise<Array<SchoolCacheData>> {
  return getCache<SchoolCacheData>(SCHOOL_CACHE_KEY);
}

export async function getAllInternalMartinusSchools(): Promise<Array<SchoolCacheData>> {
  const schools = await getCache<SchoolCacheData>(SCHOOL_CACHE_KEY);
  return schools.filter(s => s.isSgSchool);
}
